import React from "react";

export default function () {
  return (
    <div className="flex justify-center">
      <div className="w-0.5 bg-gray-900 my-16 h-20 rounded"></div>
    </div>
  );
}
